const SCHEDULE_DOWNLOAD_PATTERN = /^\/api\/v2\/projects\/[^/]+\/query\/[^/]+\/schedule-download$/;
/**
 * The one allowlisted route whose response triggers a follow-up fetch the app
 * performs OUTSIDE the bridge: the SDK anchor-clicks the returned fileUrl from
 * inside the sandboxed iframe, which cannot attach session cookies. Both
 * mediators stamp `LightdashSignedDownloadHeader` on this route so the backend
 * mints a SIGNED (token/presigned) URL that survives that credential-less
 * fetch.
 */
export const isAppSdkScheduleDownloadRoute = (method, path) => method.toUpperCase() === 'POST' && SCHEDULE_DOWNLOAD_PATTERN.test(path);
export const APP_SDK_ALLOWED_ROUTES = [
    // Async metric query execution
    {
        method: 'POST',
        pattern: /^\/api\/v2\/projects\/[^/]+\/query\/metric-query$/,
    },
    // Run a saved chart live by UUID (linked charts)
    {
        method: 'POST',
        pattern: /^\/api\/v2\/projects\/[^/]+\/query\/chart$/,
    },
    // Run underlying-data queries for SDK result rows
    {
        method: 'POST',
        pattern: /^\/api\/v2\/projects\/[^/]+\/query\/underlying-data$/,
    },
    // Poll for query results
    {
        method: 'GET',
        pattern: /^\/api\/v2\/projects\/[^/]+\/query\/[^/]+$/,
    },
    // Schedule backend CSV/XLSX export jobs for SDK query results
    {
        method: 'POST',
        pattern: SCHEDULE_DOWNLOAD_PATTERN,
    },
    // Poll export job status until the backend returns a file URL
    {
        method: 'GET',
        pattern: /^\/api\/v1\/schedulers\/job\/[^/]+\/status$/,
    },
    // Get current user
    { method: 'GET', pattern: /^\/api\/v1\/user$/ },
];
export const isAllowedAppSdkRoute = (method, path) => APP_SDK_ALLOWED_ROUTES.some((route) => route.method === method.toUpperCase() && route.pattern.test(path));
/**
 * Project uuid embedded in an app-SDK API path, or null for the routes that
 * aren't project-scoped (scheduler job status, current user). Callers that
 * pin preview traffic to one project compare this against their target.
 */
export const extractAppSdkRouteProjectUuid = (path) => {
    const match = path.match(/^\/api\/v2\/projects\/([^/]+)\//);
    return match ? match[1] : null;
};
//# sourceMappingURL=sdkBridgeRoutes.js.map